import { useState } from 'react';
import { useRoomStore } from "../../../stores/room";
import { useUserStore } from '../../../stores/user';
import { Avatar } from '../../../widgets/avatar';
import styles from "./workspace.module.css";

export function MessageList({
    messages = []
}){
    const { postMessage } = useRoomStore();
    const { name, email } = useUserStore();
    const [messageText, setMessageText] = useState("");
    return (
        <div className={styles.messageContainer}>
            <div className={styles.messageList}>
                {messages.map(message => (
                    <Message key={message.id} message={message} />
                ))}
            </div>
            <div className={styles.messageInput}>
                <form onSubmit={e => {
                    e.preventDefault();
                    postMessage({
                        user: {
                            name,
                            email
                        },
                        text: messageText
                    });
                    setMessageText("");
                }}>
                    <input type="text" placeholder="Type a message" value={messageText} onChange={e => {
                        setMessageText(e.target.value);
                    }} />
                </form>
            </div>
        </div>
    );
}

export function Message({
    message
}){
    return <div className={styles.message}>
        <div>
            <Avatar name={message.user.name} email={message.user.email} size={32} />
        </div>
        <div>
            <span>{message.text}</span>
        </div>
    </div>
}